import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import MobileStickyCTA from './components/MobileStickyCTA';

function App() {
  return (
    <LanguageProvider>
      <div className="font-sans text-gray-900 w-full overflow-x-hidden bg-paper">
        <Header />
        <main className="pb-20 md:pb-0"> {/* Extra padding for mobile sticky bar */}
          <Hero />
          <Services />
          <About />
          <Testimonials />
          <CTA />
        </main>
        <Footer />
        <FloatingWhatsApp />
        <MobileStickyCTA />
      </div>
    </LanguageProvider>
  );
}

export default App;